import { isOpenFin } from 'utils'

export default isOpenFin() ? require('./RFQTicketOpenFin').default : require('./RFQTicketBrowser').default
